var alignment_rtlignore_default = {
  "alignLeft": "c-o23",
  "textWrapNowrap": "S388h",
  "alignRight": "LLrQk",
  "alignCenter": "roTx-",
  "sizeFullWidth": "_9Lpq-",
  "renderedInTable": "_69lbf",
  "sizeOriginal": "k1Xj7",
  "sizeContent": "_2e63G",
  "sizeSmall": "GxsdL",
  "sizeSmallCenter": "qEXSR",
  "flex": "B8u34",
  "LEFT": "_1XQGO",
  "CENTER": "htKR-",
  "RIGHT": "sf56n",
  "AUTO": "t3L08",
  "JUSTIFY": "ON3oL"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
